import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <MediaSection />
        <CarouselSection />
        <FaqSection />
        <AboutSection />
        <RankingSection />
        <CommentsSection />
        <ContactSection />
        <TopicsSection />
        <FeaturesSection />
        <UpdatesSection />
        <CardsSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}